import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { endPollRequested } from 'features/polls/actions';

export function* endPollSaga(action: ReturnType<typeof endPollRequested>) {
  yield call(SignalingSocket.send, { event: 'endPoll', data: { id: action.payload } });
}
